import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { createEffect } from '@ngrx/effects';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import Keycloak, { KeycloakTokenParsed } from 'keycloak-js';
import { of, switchMap, withLatestFrom } from 'rxjs';

import * as AuthenticationActions from './authentication.actions';

@Injectable()
export class AuthenticationEffects {
  sessionChanged$ = createEffect(() =>
    this.keycloakService.keycloakEvents$.pipe(
      withLatestFrom(this.route.queryParams),
      switchMap(([event, params]) => {
        const token: KeycloakTokenParsed | undefined = this.keycloakService.getKeycloakInstance().tokenParsed;

        const roles: string[] = token?.realm_access?.roles ?? [];

        switch (event.type) {
          case KeycloakEventType.OnAuthError:
          case KeycloakEventType.OnAuthLogout:
          case KeycloakEventType.OnAuthRefreshError:
            return of(
              AuthenticationActions.changed({
                authenticated: false,
                employee: false,
                exclude_analytics:
                  roles.includes('planoneEmployee') ||
                  roles.includes('excludeAnalytics') ||
                  Object.keys(params).includes('intern'),
                sub: undefined,
              })
            );
          case KeycloakEventType.OnAuthRefreshSuccess:
          case KeycloakEventType.OnAuthSuccess:
            return of(
              AuthenticationActions.changed({
                authenticated: true,
                employee: roles.includes('planoneEmployee'),
                exclude_analytics:
                  roles.includes('planoneEmployee') ||
                  roles.includes('excludeAnalytics') ||
                  Object.keys(params).includes('intern'),
                sub: token?.sub,
                userInfo: {
                  givenName: token ? token['given_name'] : undefined,
                  familyName: token ? token['family_name'] : undefined,
                  email: token ? token['email'] : undefined,
                },
              })
            );
        }

        return of(AuthenticationActions.unchanged());
      })
    )
  );

  analyticsExcludeByURLParam$ = createEffect(() =>
    this.route.queryParams.pipe(
      switchMap((params) => {
        const instance: Keycloak = this.keycloakService.getKeycloakInstance();
        const roles: string[] = instance?.tokenParsed?.realm_access?.roles ?? [];

        return of(
          AuthenticationActions.changed({
            exclude_analytics:
              roles.includes('planoneEmployee') ||
              roles.includes('excludeAnalytics') ||
              Object.keys(params).includes('intern'),
          })
        );
      })
    )
  );

  constructor(private keycloakService: KeycloakService, private route: ActivatedRoute) {}
}
